import React, { useEffect } from 'react';
import $ from 'jquery';
import { useQuery, useMutation } from '@apollo/client';
import Popup from './popup';
import { CLIENT_STATE, SET_CLIENT_STATE } from '../../../graphqls';

export default function Modal({ startPolling, stopPolling }) {
  const { loading, data = {} } = useQuery(CLIENT_STATE);
  const [setState] = useMutation(SET_CLIENT_STATE);

  const { modalTypeShown } = data;

  useEffect(() => {
    if (modalTypeShown) {
      $('body').css('overflow', 'hidden');
    }
  }, [modalTypeShown]);

  if (loading || !modalTypeShown) {
    return '';
  }

  const onClose = () => setState({ variables: { modalTypeShown: '' } });

  let modalClass;

  switch (modalTypeShown) {
    case 'commonBanner':
      modalClass = 'modal-banner';
      break;
    case 'bannerImage':
      modalClass = 'modal-banner';
      break;
    case 'featureImage':
      modalClass = 'modal-feature';
      break;
    default:
      modalClass = 'modal-logo';
      break;
  }

  let header = modalTypeShown.replace(/([A-Z])/g, ' $1');

  if (header === 'css Editor') {
    header = 'CSS Editor';
  } else {
    header = header.charAt(0).toUpperCase() + header.slice(1);
  }

  return (
    <div className={`modal show ${modalTypeShown}`}>
      <div className={`modal-dialog lg ${modalClass}`}>
        <div className="modal-content">
          <div className="modal-header">
            <strong>{header}</strong>
            <button type="button" className="close" onClick={onClose}>
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Popup startPolling={startPolling} stopPolling={stopPolling} />
          </div>
        </div>
      </div>
    </div>
  );
}
